@if (label) {
  <span class="impact-pill" [ngClass]="impactClass">{{ label }}</span>
} @else {
  <span class="impact-pill__empty">—</span>
}
